import {paletteR4, fontSizesMixinsMobileR4, fontSizesMixinsR4} from '../../../../lib/styleVariablesR4';
import styled from 'styled-components';
import {mediaBreakpointDown} from '../../../../lib/styleVariables';

const gradientColors: Array<{color: string; name: string}> = [
  {
    color: paletteR4.red.base,
    name: 'red'
  },
  {
    color: paletteR4.blue.base,
    name: 'blue'
  },
  {
    color: paletteR4.green.base,
    name: 'green'
  },
  {
    color: paletteR4.orange.base,
    name: 'orange'
  }
];

const gradientSvgUrl = (color: string) => {
  const svgString = `
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' 
    xmlns='http://www.w3.org/2000/svg'><ellipse cx='12' cy='12' rx='12' ry='12' 
    fill='url(#paint0_radial)' />
      <defs>
        <radialGradient id='paint0_radial' cx='0' cy='0' r='1' 
          gradientUnits='userSpaceOnUse' 
          gradientTransform='translate(12 12) 
          rotate(90) scale(12)' >
            <stop stop-color='${color}'/>
            <stop offset='1' stop-color='${color}' stop-opacity='0'/>
        </radialGradient>
      </defs>
    </svg>
  `;

  return `"data:image/svg+xml,${encodeURIComponent(svgString)}"`;
};
const gradientBulletStyle = (variableName: string, index: number) =>
  `&:nth-child(${gradientColors.length}n+${index + 1}) {
     list-style-image: var(${variableName});
  };`;

export const StyledGradientBulletLi = styled.li`
  margin-bottom: 32px;
  padding-left: 8px;

  > p {
    text-align: left;
    ${fontSizesMixinsR4.p1()}
    ${mediaBreakpointDown('tablet')} {
      ${fontSizesMixinsMobileR4.p3()}
    }
  }

  :last-child {
    margin-bottom: 0px;
  }

  ${gradientColors.map(({name}, index) => gradientBulletStyle(`--gradient-${name}`, index)).join('\n')}
`;

export const StyledGradientBulletUl = styled.ul`
  margin-bottom: 40px;

  ${mediaBreakpointDown('tablet')} {
    margin-bottom: 0px;
  }

  ${gradientColors.map(({color, name}) => `--gradient-${name}: url(${gradientSvgUrl(color)});`).join('\n\n')}
`;
